import { render, staticRenderFns } from "./TgRegisterMobileDialog.vue?vue&type=template&id=89bbd90c"
import script from "./TgRegisterMobileDialog.vue?vue&type=script&lang=js"
export * from "./TgRegisterMobileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports